<template>
  <header
    class="page-header"
    data-gtm-context="Hero"
    :class="[{ 'page-header--dark': theme == 'dark' }, classIn]"
  >
    <div class="container-fluid">
      <div 
        class="row page-header__row" 
        :class="textAlign === 'left' ? 'page-header__row--left' : 'page-header__row--center'"
      >
        <h1
          class="mb-5 page-header__title"
          :class="[
            textAlign === 'left' ? 'text-start' : 'text-center',
            { 'hero-fade-in': fade },
          ]"
          v-html="title"
        ></h1>
        <p
          class="d-block p--lg page-header__subtitle"
          :class="[
            textAlign === 'left' ? 'text-start' : 'text-center',
            { 'hero-fade-in hero-fade-in--delay-1': fade },
          ]"
          v-if="subtitleText"
        >
          {{ subtitleText }}
        </p>

        <slot name="pageLinks"></slot>

        <slot name="image"></slot>

        <div :class="{ 'hero-fade-in hero-fade-in--delay-2': fade }">
          <slot></slot>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "PageHeader",
  components: {},
  props: {
    class: {
      type: String,
    },
    title: {
      type: String,
      required: true,
    },
    subtitleText: {
      type: String,
      required: false,
    },
    image: {
      type: String,
      required: false,
    },
    theme: {
      type: String,
    },
    textAlign: {
      type: String,
      default: 'center',
      validator: (value) => ['center', 'left'].includes(value)
    },
    fade: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      classIn: this.class,
    };
  },
};
</script>

<style scoped>
.page-header__row {
  flex-direction: column;
}

.page-header__row--center {
  align-items: center;
}

.page-header__row--left {
  align-items: flex-start;
}

.page-header__title {
  max-width: 800px;
  font-size: 80px;
  line-height: 88px;
}

.page-header__subtitle {
  max-width: 600px;
}

@media (max-width: 768px) {
  .page-header__title {
    font-size: 40px;
    line-height: 48px;
    margin: 2rem 0 2rem 0 !important;
  }

  .page-header__subtitle {
    font-size: 0.9rem;
    width: 80% !important;
  }
}

/* Hero fade-in animation */
@keyframes heroFadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.hero-fade-in {
  animation: heroFadeInUp 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  opacity: 0;
}

.hero-fade-in--delay-1 {
  animation-delay: 0.15s;
}

.hero-fade-in--delay-2 {
  animation-delay: 0.3s;
}
</style>
